import React from 'react';
import { faLocationArrow } from '@fortawesome/pro-solid-svg-icons/faLocationArrow';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function LocationArrowSolidIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faLocationArrow} {...props} />;
}
